export const SpotifyIcon = ({ className }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 48 48" width="64" height="64">
    <circle fill="#1DB954" cx="24" cy="24" r="20" />
    <path
      fill="#191414"
      d="M33.5 32.3c-.4 0-.7-.1-1-.4-4.5-2.7-10-3-14.8-1.9-.5.1-1 .2-1.4.2-.8 0-1.4-.6-1.4-1.4 0-.9.5-1.4 1.3-1.6 5.6-1.3 12.1-.9 17.4 2.2.7.4 1 .9 1 1.6-.1.8-.6 1.3-1.1 1.3zM35.6 26.8c-.4 0-.8-.2-1.1-.4-5.2-3.1-12.4-4-18.2-2.2-.4.1-.7.2-1 .2-1 0-1.7-.8-1.7-1.7 0-1 .5-1.6 1.4-1.9 6.9-2.1 15.3-1.1 21.5 2.6.7.4 1.1 1 1.1 1.8 0 1-.7 1.6-2 1.6zM14.2 18.3c-.4.1-.7.2-1 .2-1.1 0-2-.9-2-2.1 0-1.1.6-1.8 1.6-2.2 3.5-1.1 7.3-1.6 11.1-1.6 4.6 0 9.1.8 13.2 2.7.9.4 1.4 1.1 1.4 2.1 0 1.2-.9 2.1-2.1 2.1-.4 0-.7-.1-1.1-.3-3.6-1.6-7.5-2.3-11.4-2.3-3.3 0-6.6.4-9.7 1.4z"
    />
  </svg>
);
